import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function FlowMeterSVG({ value, config = {}, width = 60, height = 40 }) {
    const v = parseFloat(value ?? 0);
    const flowing = v > 0;
    const color = flowing ? '#3B82F6' : '#475569';
    const cx = width / 2, cy = height / 2;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Body diamond */}
            <polygon points={`${cx},${6} ${width - 8},${cy} ${cx},${height - 6} ${8},${cy}`}
                fill="#1E293B" stroke={color} strokeWidth={2} />
            {/* Flow lines */}
            {flowing && [0, 1].map(i => (
                <line key={i} x1={cx - 8 + i * 16} y1={cy - 5} x2={cx - 8 + i * 16} y2={cy + 5}
                    stroke={color} strokeWidth={2} strokeLinecap="round" />
            ))}
            {/* Value */}
            <text x={cx} y={cy + 4} textAnchor="middle" fill="#F1F5F9" fontSize={8} fontFamily="monospace">
                {isNaN(v) ? '--' : `${v.toFixed(1)}`}
            </text>
        </svg>
    );
}

export default function FlowMeterNode(props) {
    const { data } = props;
    return (
        <BaseScadaNode {...props}>
            <FlowMeterSVG value={data?.liveValue} config={data?.config} width={data?.width || 60} height={data?.height || 40} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
